import { render, staticRenderFns } from "./mypicinvitetable.vue?vue&type=template&id=3fbb4fb0&scoped=true&"
import script from "./mypicinvitetable.vue?vue&type=script&lang=js&"
export * from "./mypicinvitetable.vue?vue&type=script&lang=js&"
import style0 from "./mypicinvitetable.vue?vue&type=style&index=0&id=3fbb4fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb4fb0",
  null
  
)

export default component.exports